export const LessonType = {
    VIDEO: 'video',
    PDF: 'pdf'
}